import type {LocalizationService} from 'shared/providers/localization.provider';
import type {ToastMessageService} from 'shared/components/kp-toast-messages/toast-message.service';
import type LoginService from './login.service';
import type CurrentAuthService from 'shared/services/current-auth.service';

export class LoginValidityChecker {
    private static readonly SESSION_VALIDITY = 1000 * 60 * 30; // 30m - same as in application.yml
    private static readonly SESSION_VALID_STORAGE_KEY = 'sessionValidUntil';

    private thisWindowLoginAction = false;

    constructor(private toastMessageService: ToastMessageService,
                private loginService: LoginService,
                private currentAuthService: CurrentAuthService,
                private localizationService: LocalizationService) {

        this.registerStorageListener();
    }

    public registerStorageListener(): void {
        window.addEventListener('storage', (event) => {
            if (event.key !== LoginValidityChecker.SESSION_VALID_STORAGE_KEY) {
                return;
            }

            const loggedIn = this.currentAuthService.getCurrentAuthValue().evided;

            if (!this.thisWindowLoginAction) {
                if (event.newValue === null && loggedIn) {
                    this.toastMessageService.showWarning(this.localizationService.get(/* @kp-localization login.LoggedOutFromDifferentTab */ 'login.LoggedOutFromDifferentTab'));
                    this.loginService.logout(null, false);
                }

                if (event.newValue !== null && !loggedIn) {
                    this.loginService.refresh().then((auth) => {
                        if (auth.evided) {
                            this.toastMessageService.showSuccess(this.localizationService.get(/* @kp-localization login.LoggedInFromDifferentTab */ 'login.LoggedInFromDifferentTab'));
                        }
                    });
                }
            }

            this.thisWindowLoginAction = false;
        });

        window.setInterval(() => {
            const validUntil = localStorage.getItem(LoginValidityChecker.SESSION_VALID_STORAGE_KEY);

            if (validUntil && Date.now() > Number(validUntil) && this.currentAuthService.getCurrentAuthValue().evided) {
                this.loginService.refresh().then((auth) => {
                    if (!auth.evided) {
                        this.toastMessageService.showWarning(this.localizationService.get(/* @kp-localization login.SessionExpired */ 'login.SessionExpired'));
                        this.loginService.logout(null, false);
                    }
                });
            }
        }, 5000);
    }

    public removeValidityFromStorage(): void {
        this.thisWindowLoginAction = true;
        localStorage.removeItem(LoginValidityChecker.SESSION_VALID_STORAGE_KEY);
    }

    public updateValidityInStorage(): void {
        this.thisWindowLoginAction = true;
        localStorage.setItem(LoginValidityChecker.SESSION_VALID_STORAGE_KEY, String(Date.now() + LoginValidityChecker.SESSION_VALIDITY));
    }
}